module.exports = "<nav> \n  <h1>{{ navBarCtrl.name }} NAV BAR NAV BAR</h1>\n</nav>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./common/navbar/navbar.html
 ** module id = 24
 ** module chunks = 0
 **/